import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Card,
  CardBody,
  // CardTitle,
  // CardSubtitle,
  // CardImg,
  // CardText,
  // CardHeader,
  // CardImgOverlay,
  // CardFooter,
  // CardDeck,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  Tooltip,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

// action
import { apiError } from "../../store/actions"
import {
  createQuestionaireCategory,
  createQuestionaireCategoryReset,
} from "../../store/actions"
import { get, post } from "helpers/api_helper"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import { isEmpty } from "lodash"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import Spinners from "components/Common/Spinner"
import useQuestionnaireStore from "../../zustand/store/QuestionnaireModule"
import fn_helper from "helpers/fn_helper"

const DEF_OPTION_GENDER = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
]

const DEF_OPTION_NATIONALITY = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Thai",
    value: "Thai",
  },
]

const DEF_OPTION_MATIAL_STATUS = [
  {
    label: "Any",
    value: "any",
  },
  {
    label: "Single",
    value: "Single",
  },
  {
    label: "Married",
    value: "Married",
  },
]

const LANG_CODE_OPTION = [
  { id: "en-US", name: "EN" },
  { id: "th-TH", name: "TH" },
  { id: "ja-JP", name: "JP" },
  { id: "vi-VN", name: "VT" },
  { id: "zh-TW", name: "CN" },
  { id: "zh-CN", name: "CN SIMPLIFIED" },
]

const CN_RULES_MESSAGE =
  "Fail Message: If the user scores low on 6 different questions out of the 8 total, display the fail message and end the interview."

const CN_REMINDER_MESSAGE =
  "Warning: 您的回答尚未達到標準。為了繼續並獲得獎勵，請提供完整且相關的回答。若仍未改善，問卷將提前結束，且您將失去參與資格。感謝您的配合！如果您已準備好回答下一題，請輸入「繼續」。"

const CN_FAIL_MESSAGE =
  "Fail: 很遺憾地通知您，由於您的條件與本次調查不符，或是回答內容未通過品質檢測，我們將無法讓您繼續完成本次問卷。因此，您也將無法獲得相應的獎勵。感謝您的寶貴時間與參與，並期望未來有機會邀請您參加其他研究。感謝您的理解！"

const CN_PASS_MESSAGE =
  "Pass: 我們很高興通知您，您已完成本次問卷！您的意見對我們非常重要。我們將於活動結束後 30 天內，透過LINE官方賬號將獎勵發送給您。若您達成了額外獎勵進度的條件，對應的額外獎勵也將一併發送。再次誠摯感謝您撥冗參與本次問卷調查！後續我們將不定期地邀請您參與更多的研究，敬請期待 ！"

const CN_DEFAULT_CRITERIAS = [
  {
    criteria_name: "Relevance",
    criteria_checkbox: true,
    criteria_text: "生成的問題是否與受訪者的回答內容及訪談主題相關。",
    criteria_context: "我通常用車來通勤，週末會和家人一起出遊。",
    criteria_good:
      "您週末通常會和家人去哪些地方？在這些情境中，您的車子是如何支持這些活動的？",
    criteria_poor: "您平常會搭乘大眾運輸嗎？",
    criteria_bad: "您最喜歡的顏色是什麼？",
  },
  {
    criteria_name: "Clarity",
    criteria_checkbox: true,
    criteria_text: "生成的問題是否表達清楚且容易理解。",
    criteria_context: "我對SUV有興趣，因為感覺比較安全、空間也比較大。",
    criteria_good: "哪些具體的特點讓您覺得SUV更安全且空間更大？",
    criteria_poor: "為什麼SUV？",
    criteria_bad:
      "您能說明車輛尺寸感知與安全性之間的多重關聯性嗎？",
  },
  {
    criteria_name: "Engagement Potential",
    criteria_checkbox: true,
    criteria_text:
      "生成的問題是否能鼓勵受訪者提供更詳細、投入或具互動性的回答。",
    criteria_context: "我喜歡Toyota，因為它很可靠。",
    criteria_good:
      "您是否有過某些具體經驗，讓您特別感受到Toyota的可靠性？可以分享一下嗎？",
    criteria_poor: "您為什麼覺得Toyota可靠？",
    criteria_bad: "您喜歡Toyota嗎？",
  },
  {
    criteria_name: "Response Usefulness",
    criteria_checkbox: true,
    criteria_text:
      "該問題所引導出的受訪者回答，是否對後續分析或理解訪談主題具有實際價值。",
    criteria_context: "我打算明年買一台新車。",
    criteria_good:
      "在選擇下一台車時，哪些因素會對您的決策影響最大？例如預算、品牌、油耗或車內配備等。",
    criteria_poor: "您什麼時候會買車？",
    criteria_bad: "您喜歡開車嗎？",
  },
  {
    criteria_name: "Survey Purpose related",
    criteria_checkbox: true,
    criteria_text: "提出的問題是否與本次調查目的相關。",
    criteria_context: "我偏好電動車，因為比較環保。",
    criteria_good:
      "在考慮是否購買電動車時，您會有哪些顧慮或考量？例如充電設施、價格或續航力等。",
    criteria_poor: "您喜歡環保產品嗎？",
    criteria_bad: "您最喜歡的旅遊地點是哪裡？",
  },
]

const QuestionaireCategoryTemplate = props => {
  const { pageView = "create" } = props

  // CENTER STATE
  const questionnaireStore = useQuestionnaireStore() // STATE
  const { setStep1, resetQuestionnaire } = useQuestionnaireStore() // ACTION

  const isBackPage = questionnaireStore?.isLoaded ?? false

  const navigate = useNavigate()
  const [rootMenu, subMenu, action] = location.pathname.split("/")

  const { categoryId } = useParams()

  const [sendQuestion, setSendQuestion] = useState(false)

  const [verticalActiveTab, setverticalActiveTab] = useState("1")

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [tooltipOpen2, setTooltipOpen2] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)
  const toggle2 = () => setTooltipOpen2(!tooltipOpen2)

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  const [genderInvalid, setGenderInvalid] = useState(true)
  const genderInvalidClass = classnames({
    "select-basic-single": true,
    "is-invalid": genderInvalid,
  })

  const [nationalityInvalid, setNationalityInvalid] = useState(true)
  const nationalityInvalidClass = classnames({
    "select-basic-single": true,
    "is-invalid": nationalityInvalid,
  })

  const [martialInvalid, setMartialInvalid] = useState(true)
  const martialInvalidClass = classnames({
    "select-basic-single": true,
    "is-invalid": martialInvalid,
  })

  const [genderDropdown, setGenderDropdown] = useState(DEF_OPTION_GENDER)
  const [genderSelected, setGenderSelected] = useState()

  const [nationalityDropdown, setNationalityDropdown] = useState(
    DEF_OPTION_NATIONALITY
  )
  const [nationalitySelected, setNationalitySelected] = useState()

  const [martialStatusDropdown, setMartialStatusDropdown] = useState(
    DEF_OPTION_MATIAL_STATUS
  )
  const [martialStatusSelected, setMartialStatusSelected] = useState()

  const [contentDetailLoading, setContentDetailLoading] = useState(!isBackPage)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    lang_code: Yup.string().max(255).required("Select Language Code"),
    category_name: Yup.string().max(60).required("Please Enter Category Name"),
    survey_name: Yup.string().max(60).required("Please Enter Survey Name"),
    purpose: Yup.string().required("Please Enter Purpose"),
    // age_range_start: Yup.number()
    //     .integer()
    //     .positive()
    //     .required("Please Enter Age range start")
    //     .min(1)
    //     .max(99),
    // age_range_end: Yup.number()
    //     .integer()
    //     .positive()
    //     .moreThan(Yup.ref("age_range_start"), "Please enter Age range end more than Age range start")
    //     .required("Please Enter  Age range end")
    //     .min(1)
    //     .max(99),
    // gender: Yup.string()
    //     .required("Please Enter Gender"),
    // nationality: Yup.string()
    //     .required("Please Enter Nationality"),
    // martial_status: Yup.string()
    //     .required("Please Enter Martial Status"),

    criterias: Yup.array().of(
      // Yup.object().shape({
      //     criteria_name: Yup.string().max(255).required("Fill Text"),
      //     criteria_checkbox: Yup.bool(),
      //     criteria_text: Yup.string().max(255).required("Fill Text"),
      //     criteria_context: Yup.string().max(255).required("Fill Text"),
      //     criteria_good: Yup.string().max(255).required("Fill Text"),
      //     criteria_poor: Yup.string().max(255).required("Fill Text"),
      //     criteria_bad: Yup.string().max(255).required("Fill Text"),
      // })
      Yup.object().shape({
        criteria_name: Yup.string().max(255).required("Fill Text"),
        criteria_checkbox: Yup.bool(),
        criteria_text: Yup.string()
          .max(255)
          .when("criteria_checkbox", {
            is: true,
            then: schema => schema.required("Fill Text"),
            otherwise: schema => schema.notRequired(),
          }),
        criteria_context: Yup.string()
          .max(255)
          .when("criteria_checkbox", {
            is: true,
            then: schema => schema.required("Fill Text"),
            otherwise: schema => schema.notRequired(),
          }),
        criteria_good: Yup.string()
          .max(255)
          .when("criteria_checkbox", {
            is: true,
            then: schema => schema.required("Fill Text"),
            otherwise: schema => schema.notRequired(),
          }),
        criteria_poor: Yup.string()
          .max(255)
          .when("criteria_checkbox", {
            is: true,
            then: schema => schema.required("Fill Text"),
            otherwise: schema => schema.notRequired(),
          }),
        criteria_bad: Yup.string()
          .max(255)
          .when("criteria_checkbox", {
            is: true,
            then: schema => schema.required("Fill Text"),
            otherwise: schema => schema.notRequired(),
          }),
      })
    ),
    // remarks: Yup.string().required("Please Enter Remarks"),
    rules: Yup.string().required("Please Enter Rules"),

    reminder_message: Yup.string().required("Please Enter Reminder Message"),
    fail_message: Yup.string().required("Please Enter Fail Message"),
    pass_message: Yup.string().required("Please Enter Pass Message"),
  })

  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      id: pageView == "create" ? undefined : "",
      lang_code: "",
      category_name: "",
      survey_name: "",
      purpose: "",
      // age_range_start: '',
      // age_range_end: '',
      // gender: '',
      // nationality: '',
      // martial_status: '',

      criterias: CN_DEFAULT_CRITERIAS,
      // remarks: "* For the Engagement Potential index, it's important not to ask overly specialized questions that the respondent may not be able to answer.\n* In the Information Gain index, it's important to ensure that the questions do not repeat previously asked questions or any predetermined fixed questions.\n* AI needs to follow the predetermined rules.",
      rules: CN_RULES_MESSAGE,
      reminder_message: CN_REMINDER_MESSAGE,
      fail_message: CN_FAIL_MESSAGE,
      pass_message: CN_PASS_MESSAGE,
    },
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      localStorage.setItem("categoryData", JSON.stringify(values))
      setStep1({ step1: values }) // เก็บค่าเข้า STATE CENTER
      if (["update", "view"].includes(pageView)) {
        localStorage.setItem("categoryId", JSON.stringify(values.id))
        navigate(`/questionnaire/edit/` + categoryId)
      } else {
        console.log("🚀 ~ QuestionaireCategory ~ values:", values)
        navigate(`/questionnaire/create`)
      }
    },
  })

  // Custom handleChange function
  const customHandleChange = (e, index) => {
    const { name, value } = e.target

    // Example: Perform custom logic, e.g., transforming value
    let transformedValue = value // Example transformation

    // Update Formik's field value with transformed value
    validation.setFieldValue(name, transformedValue)

    // Call Formik's handleChange
    validation.handleChange(e)
  }

  const preFillForm = (formData = {}) => {
    const useChinaPreset = String(categoryId) === "8"

    validation.setFieldValue("id", formData.id)
    validation.setFieldValue("lang_code", formData.lang_code)
    validation.setFieldValue("category_name", formData.category_name)
    validation.setFieldValue("survey_name", formData.survey_name)
    validation.setFieldValue("purpose", formData.purpose)

    validation.setFieldValue("rules", useChinaPreset ? CN_RULES_MESSAGE : formData.rules)
    validation.setFieldValue("remarks", formData.remarks)

    validation.setFieldValue(
      "reminder_message",
      useChinaPreset ? CN_REMINDER_MESSAGE : formData.reminder_message
    )
    validation.setFieldValue(
      "fail_message",
      useChinaPreset ? CN_FAIL_MESSAGE : formData.fail_message
    )
    validation.setFieldValue(
      "pass_message",
      useChinaPreset ? CN_PASS_MESSAGE : formData.pass_message
    )

    // SET VIEW ARRAY FORM
    console.log("🚀 ~ fetchContent: ~ formData.criterias:", formData.criterias)
    let preFillCriterias = []
    if (useChinaPreset) {
      preFillCriterias = CN_DEFAULT_CRITERIAS
    } else if (formData.criterias && Array.isArray(formData.criterias)) {
      preFillCriterias = formData.criterias
    }
    validation.setFieldValue("criterias", preFillCriterias)
  }

  const API = {
    fetchContent: async () => {
      setContentDetailLoading(true)
      const result = await get(
        process.env.REACT_APP_BACKEND_URL +
          "/v1/admin/questionnaire/category/" +
          categoryId
      )
      const resData = result.data
      console.log("🚀 ~ fetchContent: ~ resData:", resData)

      // PREFILE INPUT FORM
      preFillForm(resData)

      setContentDetailLoading(false)
    },
  }

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ questionnaireStore:", questionnaireStore)

    if (isBackPage) {
      const oldData = questionnaireStore.step1
      preFillForm(oldData)
    }

    if (pageView !== "create") {
      API.fetchContent()
    }
  }, [])

  if (contentDetailLoading && pageView !== "create") {
    return <Spinners setLoading={setContentDetailLoading} />
  }

  const PageAction = pageView
  document.title =
    `Questionnaire | ${PageAction} Category | ` +
    process.env.REACT_APP_CMS_TITLE

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={false}>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={"Questionnaire"}
            breadcrumbItems={[
              { title: "Questionnaire", link: "questionnaire" },
              { title: "Create Category", link: "category" },
            ]}
          />
          <div className="bInnerContent">
            <Row>
              <Col>
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Card>
                      <CardBody>
                        <Row className="mb-3">
                          <h4 className="mb-3">
                            {_.startCase(pageView)} Questionnaire Category
                          </h4>
                          <Col className="col-12">
                            <label
                              htmlFor="category_name"
                              className="col-md-2 col-form-label"
                            >
                              Language
                            </label>
                            <div className="col-md-4">
                              <Select
                                id="lang_code"
                                placeholder="Select Language"
                                value={fn_helper.FNFORM.getObjectValue(
                                  LANG_CODE_OPTION,
                                  `${validation.values.lang_code}`
                                )}
                                onChange={value =>
                                  validation.setFieldValue(
                                    "lang_code",
                                    value.id
                                  )
                                }
                                getOptionValue={option => option.id}
                                getOptionLabel={option => option.name}
                                options={LANG_CODE_OPTION}
                                className={`select2-selection ${
                                  validation.touched.lang_code &&
                                  validation.errors.lang_code
                                    ? "input-err"
                                    : ""
                                }`}
                                isDisabled={pageView === "view"}
                              />
                              {/* {
                                                            // (validation.touched.lang_code && validation.errors.lang_code) && (
                                                            <div type="invalid" className="invalid-feedback d-block">{validation.errors.lang_code}</div>
                                                            // )
                                                        } */}
                              {validation.touched.lang_code &&
                              validation.errors.lang_code ? (
                                <div
                                  type="invalid"
                                  className="invalid-feedback d-block"
                                >
                                  {validation.errors.lang_code}
                                </div>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="col-12">
                            <label
                              htmlFor="category_name"
                              className="col-md-2 col-form-label"
                            >
                              Category
                            </label>
                            <div className="col-md-4">
                              <Input
                                id="category_name"
                                className="form-control"
                                type="text"
                                placeholder="eg. Travel in Japan / Skincare / Car"
                                name="category_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.category_name}
                                invalid={
                                  validation.touched.category_name &&
                                  validation.errors.category_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.category_name &&
                              validation.errors.category_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.category_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="col-12">
                            <label
                              htmlFor="survey_name"
                              className="col-md-2 col-form-label"
                            >
                              Name
                            </label>
                            <div className="col-md-4">
                              <Input
                                id="survey_name"
                                className="form-control"
                                type="text"
                                placeholder="eg. survey_name"
                                name="survey_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.survey_name}
                                invalid={
                                  validation.touched.survey_name &&
                                  validation.errors.survey_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.survey_name &&
                              validation.errors.survey_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.survey_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="col-12 mb-3">
                            <label htmlFor="purpose" className="col-form-label">
                              Survey Purpose
                            </label>
                            <div>
                              <Input
                                id="purpose"
                                className="form-control"
                                type="textarea"
                                style={{ resize: "none" }}
                                rows="5"
                                placeholder="eg. The purpose of this interview is to understand the travel experiences of foreign tourists in Japan, to gain a deep understanding of their travel motivations, cultural adaptation and overall satisfaction in Japan"
                                name="purpose"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.purpose}
                                invalid={
                                  validation.touched.purpose &&
                                  validation.errors.purpose
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.purpose &&
                              validation.errors.purpose ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.purpose}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>

                        {/* <Row className="mb-3">
                                                <h5 className="mb-3">Respondent Condition</h5>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="age_range_start"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Age range:
                                                    </label>
                                                    <div className="col-md-10">
                                                        <Row className="d-flex align-items-center">
                                                            <Col className="col-md-6">
                                                                <InputGroup>
                                                                    <div>
                                                                        <Input
                                                                            type="number"
                                                                            id="age_range_start"
                                                                            name="age_range_start"
                                                                            value={validation.values.age_range_start}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            invalid={
                                                                                validation.touched.age_range_start && validation.errors.age_range_start ? true : false
                                                                            }
                                                                            min={1}
                                                                            max={99}
                                                                        />
                                                                        {validation.touched.age_range_start && validation.errors.age_range_start ? (
                                                                            <FormFeedback type="invalid">{validation.errors.age_range_start}</FormFeedback>
                                                                        ) : null}
                                                                    </div>
                                                                    <span className="input-group-text">-</span>
                                                                    <div>
                                                                        <Input
                                                                            type="number"
                                                                            id="age_range_end"
                                                                            name="age_range_end"
                                                                            value={validation.values.age_range_end}
                                                                            onChange={validation.handleChange}
                                                                            onBlur={validation.handleBlur}
                                                                            invalid={
                                                                                validation.touched.age_range_end && validation.errors.age_range_end ? true : false
                                                                            }
                                                                            min={1}
                                                                            max={99}
                                                                        />
                                                                        {validation.touched.age_range_start && validation.errors.age_range_start ? (
                                                                            <FormFeedback type="invalid">{validation.errors.age_range_start}</FormFeedback>
                                                                        ) : null}
                                                                    </div>
                                                                </InputGroup>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="age_range"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Gender:
                                                    </label>
                                                    <div className="col-md-2">
                                                        <CreatableSelect
                                                            id="gender"
                                                            name="gender"
                                                            value={genderSelected}
                                                            onChange={(selectedOption) => {
                                                                setGenderSelected(selectedOption)
                                                                validation.setFieldValue("gender", selectedOption.value)
                                                                isEmpty(validation.values.gender) ? setGenderInvalid(true) : setGenderInvalid(false)
                                                                // validation.touched.gender && validation.errors.gender
                                                                //     ? setGenderInvalid(true)
                                                                //     : setGenderInvalid(false)
                                                            }}
                                                            // onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            options={genderDropdown}
                                                            // className="basic-single"
                                                            // classNamePrefix="select"
                                                            className={genderInvalidClass}
                                                            aria-invalid={
                                                                validation.touched.gender && validation.errors.gender ? true : false
                                                            }
                                                        />
                                                        {validation.touched.gender && validation.errors.gender ? (
                                                            <FormFeedback type="invalid">{validation.errors.gender}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="age_range"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Nationality:
                                                    </label>
                                                    <div className="col-md-2">
                                                        <CreatableSelect
                                                            id="nationality"
                                                            name="nationality"
                                                            value={nationalitySelected}
                                                            onChange={(selectedOption) => {
                                                                setNationalitySelected(selectedOption)
                                                                validation.setFieldValue("nationality", selectedOption.value)
                                                                validation.touched.gender && validation.errors.gender
                                                                    ? setNationalityInvalid(true)
                                                                    : setNationalityInvalid(false)
                                                            }}
                                                            onSubmit={() => {
                                                                validation.touched.gender && validation.errors.gender
                                                                    ? setNationalityInvalid(true)
                                                                    : setNationalityInvalid(false)
                                                            }}
                                                            options={nationalityDropdown}
                                                            className={nationalityInvalidClass}
                                                            // className="basic-single"
                                                            // classNamePrefix="select"
                                                            aria-invalid={
                                                                validation.touched.nationality && validation.errors.nationality ? true : false
                                                            }
                                                        />
                                                        {validation.touched.nationality && validation.errors.nationality ? (
                                                            <FormFeedback type="invalid">{validation.errors.nationality}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Row>
                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="age_range"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Martial Status:
                                                    </label>
                                                    <div className="col-md-2">
                                                        <CreatableSelect
                                                            id="martial_status"
                                                            name="martial_status"
                                                            value={martialStatusSelected}
                                                            onChange={(selectedOption) => {
                                                                setMartialStatusSelected(selectedOption)
                                                                validation.setFieldValue("martial_status", selectedOption.value)
                                                            }}
                                                            onSubmit={() => {
                                                                validation.touched.gender && validation.errors.gender
                                                                    ? setMartialInvalid(true)
                                                                    : setMartialInvalid(false)
                                                            }}
                                                            options={martialStatusDropdown}
                                                            className={martialInvalidClass}
                                                            // className="basic-single"
                                                            // classNamePrefix="select"
                                                            invalid={
                                                                validation.touched.martial_status && validation.errors.martial_status ? true : false
                                                            }
                                                        />
                                                        {validation.touched.martial_status && validation.errors.martial_status ? (
                                                            <FormFeedback type="invalid">{validation.errors.martial_status}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Row>
                                            </Row> */}

                        <Row className="mb-3">
                          <h5
                            className="mb-3"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <span>AI add-on Question Criteria</span>
                            <i
                              className="bx bxs-info-circle hoverShow"
                              id="tooltip-ai-add-on"
                            ></i>
                          </h5>
                          <Tooltip
                            placement="top"
                            isOpen={tooltipOpen}
                            target="tooltip-ai-add-on"
                            toggle={toggle}
                          >
                            <div>
                              Depending on the respondent’s answers, AI will
                              generate add-on questions by 5 criteria as below
                              (Relevance, Clarity, Engagement Potential,
                              Response usefulness, Information gain as
                              default).​ Please input an example for each
                              criterion.
                            </div>
                          </Tooltip>
                          <Col md="3">
                            <Nav pills className="flex-column">
                              <FieldArray name="criterias">
                                {({ push, remove }) => (
                                  <>
                                    {validation.values.criterias.map(
                                      (cr, index) => (
                                        <NavItem key={index}>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                              "mb-2": true,
                                              active:
                                                verticalActiveTab ===
                                                `${index + 1}`,
                                            })}
                                            onClick={() => {
                                              toggleVertical(`${index + 1}`)
                                            }}
                                          >
                                            {verticalActiveTab ===
                                            `${index + 1}` ? (
                                              <InputGroup>
                                                <div className="input-group-text">
                                                  <div className="form-check-primary">
                                                    <Input
                                                      className="form-check-input pl-5"
                                                      id={`criterias.${index}.criteria_checkbox`}
                                                      name={`criterias.${index}.criteria_checkbox`}
                                                      type="checkbox"
                                                      checked={
                                                        cr.criteria_checkbox
                                                      }
                                                      onClick={e => {
                                                        e.stopPropagation() // ป้องกันการ toggle tab เมื่อคลิก checkbox
                                                        const value =
                                                          validation.values
                                                            .criterias[index]
                                                            .criteria_checkbox
                                                        const name = `criterias.${index}.criteria_checkbox`
                                                        validation.setFieldValue(
                                                          name,
                                                          !value
                                                        )
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                                <Input
                                                  id={`criterias.${index}.criteria_name`}
                                                  name={`criterias.${index}.criteria_name`}
                                                  className="form-control"
                                                  type="text"
                                                  placeholder="Enter Criteria Name"
                                                  onChange={e =>
                                                    customHandleChange(e, index)
                                                  }
                                                  onBlur={validation.handleBlur}
                                                  value={cr.criteria_name}
                                                  invalid={
                                                    !!(
                                                      validation.touched
                                                        .criterias?.[index]
                                                        ?.criteria_name &&
                                                      validation.errors
                                                        .criterias?.[index]
                                                        ?.criteria_name
                                                    )
                                                  }
                                                />
                                                {!!(
                                                  validation.touched
                                                    .criterias?.[index]
                                                    ?.criteria_name &&
                                                  validation.errors.criterias?.[
                                                    index
                                                  ]?.criteria_name
                                                ) ? (
                                                  <FormFeedback type="invalid">
                                                    {
                                                      validation.errors
                                                        .criterias[index]
                                                        .criteria_name
                                                    }
                                                  </FormFeedback>
                                                ) : null}
                                              </InputGroup>
                                            ) : (
                                              <div className="d-flex align-items-center">
                                                {/* สำหรับ inactive tab ไม่ใช้ input-group-text */}
                                                <div className="form-check-primary me-2">
                                                  <Input
                                                    className="form-check-input pl-5"
                                                    id={`criterias.${index}.criteria_checkbox`}
                                                    name={`criterias.${index}.criteria_checkbox`}
                                                    type="checkbox"
                                                    checked={
                                                      cr.criteria_checkbox
                                                    }
                                                    onClick={e => {
                                                      e.stopPropagation() // ป้องกันการ toggle tab เมื่อคลิก checkbox
                                                      const value =
                                                        validation.values
                                                          .criterias[index]
                                                          .criteria_checkbox
                                                      const name = `criterias.${index}.criteria_checkbox`
                                                      validation.setFieldValue(
                                                        name,
                                                        !value
                                                      )
                                                    }}
                                                  />
                                                </div>
                                                <span>{cr.criteria_name}</span>
                                              </div>
                                            )}
                                          </NavLink>
                                        </NavItem>
                                      )
                                    )}
                                  </>
                                )}
                              </FieldArray>
                            </Nav>
                          </Col>
                          <Col md="9">
                            <TabContent
                              activeTab={verticalActiveTab}
                              className="text-muted mt-4 mt-md-0"
                            >
                              {/* <TabPane tabId="1"> */}
                              <FieldArray name="criterias">
                                {({ push, remove }) => (
                                  <>
                                    {validation.values.criterias.map(
                                      (criterias, index) => (
                                        <TabPane
                                          tabId={`${index + 1}`}
                                          key={index}
                                        >
                                          <Row className="mb-3">
                                            <Input
                                              id={`criterias.${index}.criteria_text`}
                                              name={`criterias.${index}.criteria_text`}
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter Criteria Name"
                                              onChange={e =>
                                                customHandleChange(e, index)
                                              }
                                              onBlur={validation.handleBlur}
                                              value={criterias.criteria_text}
                                              invalid={
                                                !!(
                                                  validation.touched
                                                    .criterias?.[index]
                                                    ?.criteria_text &&
                                                  validation.errors.criterias?.[
                                                    index
                                                  ]?.criteria_text
                                                )
                                              }
                                            />
                                            {!!(
                                              validation.touched.criterias?.[
                                                index
                                              ]?.criteria_text &&
                                              validation.errors.criterias?.[
                                                index
                                              ]?.criteria_text
                                            ) && (
                                              <FormFeedback type="invalid">
                                                {
                                                  validation.errors.criterias[
                                                    index
                                                  ].criteria_text
                                                }
                                              </FormFeedback>
                                            )}
                                          </Row>
                                          <Row className="mb-3">
                                            <Label
                                              htmlFor="criteria_clarity_context"
                                              className="col-md-3 col-form-label max-col-x"
                                            >
                                              Previous Answers:
                                            </Label>
                                            <div className="col">
                                              <Input
                                                id={`criterias.${index}.criteria_context`}
                                                name={`criterias.${index}.criteria_context`}
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter Criteria Name"
                                                onChange={e =>
                                                  customHandleChange(e, index)
                                                }
                                                onBlur={validation.handleBlur}
                                                value={
                                                  criterias.criteria_context
                                                }
                                                invalid={
                                                  !!(
                                                    validation.touched
                                                      .criterias?.[index]
                                                      ?.criteria_context &&
                                                    validation.errors
                                                      .criterias?.[index]
                                                      ?.criteria_context
                                                  )
                                                }
                                              />
                                              {!!(
                                                validation.touched.criterias?.[
                                                  index
                                                ]?.criteria_context &&
                                                validation.errors.criterias?.[
                                                  index
                                                ]?.criteria_context
                                              ) && (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors.criterias[
                                                      index
                                                    ].criteria_context
                                                  }
                                                </FormFeedback>
                                              )}
                                            </div>
                                          </Row>
                                          <Row className="mb-3">
                                            <Label
                                              htmlFor="criteria_clarity_context"
                                              className="col-md-3 col-form-label max-col-x"
                                            >
                                              Good (Score 2):
                                            </Label>
                                            <div className="col">
                                              <Input
                                                id={`criterias.${index}.criteria_good`}
                                                name={`criterias.${index}.criteria_good`}
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter Criteria Name"
                                                onChange={e =>
                                                  customHandleChange(e, index)
                                                }
                                                onBlur={validation.handleBlur}
                                                value={criterias.criteria_good}
                                                invalid={
                                                  !!(
                                                    validation.touched
                                                      .criterias?.[index]
                                                      ?.criteria_good &&
                                                    validation.errors
                                                      .criterias?.[index]
                                                      ?.criteria_good
                                                  )
                                                }
                                              />
                                              {!!(
                                                validation.touched.criterias?.[
                                                  index
                                                ]?.criteria_good &&
                                                validation.errors.criterias?.[
                                                  index
                                                ]?.criteria_good
                                              ) && (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors.criterias[
                                                      index
                                                    ].criteria_good
                                                  }
                                                </FormFeedback>
                                              )}
                                            </div>
                                          </Row>
                                          <Row className="mb-3">
                                            <Label
                                              htmlFor="criteria_clarity_context"
                                              className="col-md-3 col-form-label max-col-x"
                                            >
                                              Poor (Score 1):
                                            </Label>
                                            <div className="col">
                                              <Input
                                                id={`criterias.${index}.criteria_poor`}
                                                name={`criterias.${index}.criteria_poor`}
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter Criteria Name"
                                                onChange={e =>
                                                  customHandleChange(e, index)
                                                }
                                                onBlur={validation.handleBlur}
                                                value={criterias.criteria_poor}
                                                invalid={
                                                  !!(
                                                    validation.touched
                                                      .criterias?.[index]
                                                      ?.criteria_poor &&
                                                    validation.errors
                                                      .criterias?.[index]
                                                      ?.criteria_poor
                                                  )
                                                }
                                              />
                                              {!!(
                                                validation.touched.criterias?.[
                                                  index
                                                ]?.criteria_poor &&
                                                validation.errors.criterias?.[
                                                  index
                                                ]?.criteria_poor
                                              ) && (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors.criterias[
                                                      index
                                                    ].criteria_poor
                                                  }
                                                </FormFeedback>
                                              )}
                                            </div>
                                          </Row>
                                          <Row className="mb-3">
                                            <Label
                                              htmlFor="criteria_clarity_context"
                                              className="col-md-3 col-form-label max-col-x"
                                            >
                                              Bad (Score 0):
                                            </Label>
                                            <div className="col">
                                              <Input
                                                id={`criterias.${index}.criteria_bad`}
                                                name={`criterias.${index}.criteria_bad`}
                                                className="form-control"
                                                type="text"
                                                placeholder="Enter Criteria Name"
                                                onChange={e =>
                                                  customHandleChange(e, index)
                                                }
                                                onBlur={validation.handleBlur}
                                                value={criterias.criteria_bad}
                                                invalid={
                                                  !!(
                                                    validation.touched
                                                      .criterias?.[index]
                                                      ?.criteria_bad &&
                                                    validation.errors
                                                      .criterias?.[index]
                                                      ?.criteria_bad
                                                  )
                                                }
                                              />
                                              {!!(
                                                validation.touched.criterias?.[
                                                  index
                                                ]?.criteria_bad &&
                                                validation.errors.criterias?.[
                                                  index
                                                ]?.criteria_bad
                                              ) && (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors.criterias[
                                                      index
                                                    ].criteria_bad
                                                  }
                                                </FormFeedback>
                                              )}
                                            </div>
                                          </Row>
                                        </TabPane>
                                      )
                                    )}
                                    {/* <Button
                                                                        color="danger"
                                                                        type="button"
                                                                        onClick={() => remove(index)} // Correctly removes the banner at this index
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                    <br/>
                                                                    <Button color="primary" type="button" 
                                                                        onClick={() =>
                                                                            push({
                                                                                criteria_name: "", // Add a new empty banner
                                                                                criteria_text: "",
                                                                                criteria_context: "",
                                                                                criteria_good: "",
                                                                                criteria_poor: "",
                                                                                criteria_bad: "",
                                                                            })
                                                                        }
                                                                    >
                                                                        Add Criteria
                                                                    </Button> */}
                                  </>
                                )}
                              </FieldArray>

                              {/* </TabPane> */}
                            </TabContent>
                          </Col>
                        </Row>

                        {/* <Row className="mb-3">
                                                <div className="bTopic">
                                                    <h6>Remarks</h6>
                                                </div>
                                                <div>
                                                    <Input
                                                        type="textarea"
                                                        rows="5"
                                                        id="remarks"
                                                        name="remarks"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.remarks}
                                                        invalid={
                                                            validation.touched.remarks && validation.errors.remarks ? true : false
                                                        }
                                                    />
                                                    {validation.touched.remarks && validation.errors.remarks ? (
                                                        <FormFeedback type="invalid">{validation.errors.remarks}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Row> */}
                        <Row className="mb-3">
                          <Label className="h5" htmlFor="rules">
                            <span>User’s Answer Evaluation Criteria</span>
                          </Label>
                          <div className="bTopic">
                            <h6>Rules</h6>
                            <i
                              className="bx bxs-info-circle hoverShow"
                              id="tooltip-rules"
                            ></i>
                          </div>
                          <Tooltip
                            placement="top"
                            isOpen={tooltipOpen2}
                            target="tooltip-rules"
                            toggle={toggle2}
                          >
                            <div>
                              To prevent respondents from giving random answers,
                              we established answer evaluation criteria. If
                              respondents fail to meet these criteria multiple
                              times, they will not be able to pass the survey.
                              Researchers can edit the 'Answer Evaluation
                              Criteria' according to their needs.​ *The number
                              in '()' indicates the limit of unqualified answers
                              before the respondent receives a reminder.​ *The
                              number in '{}' indicates the limit of unqualified
                              answers before the survey is terminated for the
                              respondent.​ *The number in '[]' represents the
                              total number of 'AI-generated add-on' questions.
                            </div>
                          </Tooltip>
                          <div>
                            <Input
                              type="textarea"
                              style={{ resize: "none" }}
                              rows="5"
                              id="rules"
                              name="rules"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.rules}
                              invalid={
                                validation.touched.rules &&
                                validation.errors.rules
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.rules &&
                            validation.errors.rules ? (
                              <FormFeedback type="invalid">
                                {validation.errors.rules}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Row>
                        <Row className="mb-3">
                          <div className="bTopic">
                            <h6>Reminder Message:</h6>
                            <span>
                              Message to warning people who have given
                              unqualified answers multiple times.
                            </span>
                          </div>
                          <div>
                            <Input
                              type="textarea"
                              style={{ resize: "none" }}
                              rows="5"
                              id="reminder_message"
                              name="reminder_message"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.reminder_message}
                              invalid={
                                validation.touched.reminder_message &&
                                validation.errors.reminder_message
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.reminder_message &&
                            validation.errors.reminder_message ? (
                              <FormFeedback type="invalid">
                                {validation.errors.reminder_message}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Row>
                        <Row className="mb-3">
                          <div className="bTopic">
                            <h6>Fail Message:</h6>
                            <span>
                              Message to people who have failed the scoring
                              tests.
                            </span>
                          </div>
                          <div>
                            <Input
                              type="textarea"
                              style={{ resize: "none" }}
                              rows="5"
                              id="fail_message"
                              name="fail_message"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.fail_message}
                              invalid={
                                validation.touched.fail_message &&
                                validation.errors.fail_message
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.fail_message &&
                            validation.errors.fail_message ? (
                              <FormFeedback type="invalid">
                                {validation.errors.fail_message}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Row>
                        <Row className="mb-3">
                          <div className="bTopic">
                            <h6>Pass Message:</h6>
                            <span>
                              Message to people who completed the survey
                            </span>
                          </div>
                          <div>
                            <Input
                              type="textarea"
                              style={{ resize: "none" }}
                              rows="5"
                              id="pass_message"
                              name="pass_message"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.pass_message}
                              invalid={
                                validation.touched.pass_message &&
                                validation.errors.pass_message
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.pass_message &&
                            validation.errors.pass_message ? (
                              <FormFeedback type="invalid">
                                {validation.errors.pass_message}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Row>
                        <Row className="mb-3">
                          <Col>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {/* <Link to={"/questionaire/create"} color="primary" className="btn btn-primary waves-effect waves-light">Draft Questionaire</Link> */}
                              <Button
                                type="submit"
                                color="primary"
                                className="btn btn-primary waves-effect waves-light"
                              >
                                Draft Questionnaire{" "}
                                {sendQuestion && (
                                  <Spinner
                                    size="sm"
                                    className="ms-2"
                                    color="light"
                                  />
                                )}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(QuestionaireCategoryTemplate)
